import ReimbursementSummaryCommon, {getDefaultState as getReimbursementSummaryCommonDefaultState} from './reimbursement-summary-common';
import ReimbursementSummaryLocation from './reimbursement-summary-location';
import t from 'tcomb';

const ReimbursementSummaryCity = ReimbursementSummaryCommon.extend({
    accountSummary: t.list(ReimbursementSummaryLocation, 'AccountSummary'),
    city: t.String
}, {
    name: 'ReimbursementSummaryCity',
    strict: true
});

export const getDefaultState = () => new ReimbursementSummaryCity({
    ...getReimbursementSummaryCommonDefaultState(),
    accountSummary: [],
    city: ''
});

export default ReimbursementSummaryCity;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-city.js